document.addEventListener("DOMContentLoaded", () => {
  console.log('started'); // Keep this for debugging, remove in production
  const vatToggle = document.getElementById("vat-toggle-checkbox");
  // These selectors are correct for the HTML structure provided
  const vatIncludedLabel = document.querySelector(".switcher-label.vat-included-label");
  const vatExcludedLabel = document.querySelector(".switcher-label.vat-excluded-label");

  if (!vatToggle) {
    console.warn(
      "VAT toggle checkbox not found. Skipping price switcher initialization."
    );
    return;
  }

  // --- Core function to update price visibility and label appearance ---
  const updatePriceVisibility = (showInclVat) => {
    const pricesInclVat = document.querySelectorAll(
      ".vat-price-display.price-incl-vat"
    );
    const pricesExclVat = document.querySelectorAll(
      ".vat-price-display.price-excl-vat"
    );

    pricesInclVat.forEach((el) => (el.style.display = showInclVat ? "inline" : "none"));
    pricesExclVat.forEach((el) => (el.style.display = showInclVat ? "none" : "inline"));

    // Update label styles (add/remove 'active' class for CSS styling)
    // This correctly applies 'active' class to the currently selected label
    if (vatIncludedLabel) {
      vatIncludedLabel.classList.toggle("active", showInclVat);
    }
    if (vatExcludedLabel) {
      vatExcludedLabel.classList.toggle("active", !showInclVat);
    }
  };

  // --- Load preference from local storage on page load ---
  const savedPreference = localStorage.getItem("showPricesInclVat");

  // If preference exists, use it. Otherwise, default to VAT Excl.
  if (savedPreference !== null) {
    vatToggle.checked = savedPreference === "true";
  } else {
    // No preference saved: default to VAT Excl. (toggle off).
    vatToggle.checked = false;
  }
  // Apply the initial visibility based on the loaded preference or default state
  updatePriceVisibility(vatToggle.checked);

  // --- Event listener for toggle change ---
  vatToggle.addEventListener("change", () => {
    const showInclVat = vatToggle.checked;
    updatePriceVisibility(showInclVat);
    localStorage.setItem("showPricesInclVat", showInclVat);
  });

  // --- Handle dynamically added prices (variant changes, collection filters,
  // infinite scroll, quick view, predictive search) ---
  // New prices arrive with the server default (VAT Excl.), so re-apply the
  // current toggle state whenever price elements are added anywhere on the page.
  const observePriceChanges = () => {
    const observer = new MutationObserver((mutationsList) => {
      const vatPriceElementsAdded = mutationsList.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches(".vat-price-display") ||
              node.querySelector(".vat-price-display") ||
              node.closest(".vat-price-display"))
        )
      );

      if (vatPriceElementsAdded) {
        updatePriceVisibility(vatToggle.checked);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  // Initialize observer for existing price elements
  observePriceChanges();
});